import util from '../../libs/utils'

export function handleOptions (defaultConfig, options) {
  const result = util.merge(defaultConfig, options)
  return result
}
